import { FormLabel, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import OTPInput from "react-otp-input";

import { motion } from "framer-motion";

import "./SmsReceiver.scss";
import { isMobile } from "react-device-detect";
import ResendCodeCountDown from "../ResendCodeCountDown/ResendCodeCountDown";
import { BasicButton } from "../generic-components/button/Button";
import "./SmsReceiver.scss";

interface SmsReceiverProps {
  smsLogin: (code: string) => void;
  onResendCode: () => void;
  isLoading: boolean;
}

const SmsReceiver: React.FC<SmsReceiverProps> = ({
  smsLogin,
  onResendCode,
  isLoading,
}) => {
  const [code, setCode] = useState<string>("");

  return (
    <form className="auth-container" onSubmit={(e) => e.preventDefault()}>
      <motion.div
        animate={{ x: [-window.innerWidth, 0] }}
        transition={{ duration: isMobile ? 0.4 : 0.6 }}
        className="login-container-desktop"
      >
        <Stack className="text-container-desktop" alignItems="start">
          <Typography className="title">אנא הזינו את קוד האימות</Typography>
          <Typography className="description">
            שלחנו אליכם קוד אימות בהודעת SMS
          </Typography>
        </Stack>
        <div className="user-phone-container">
          {isMobile ?
            <>
              <OTPInput
                shouldAutoFocus
                inputType="number"
                containerStyle={isMobile ? {
                  direction: "ltr",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  gap: "3vw",
                } : {
                  direction: "ltr",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  gap: "0.8vw",
                }}
                onPaste={() => { }}
                value={code}
                onChange={setCode}
                numInputs={4}
                renderInput={(props) => (
                  <input
                    {...props}
                    style={{}}
                    id="code"
                    className="number-input"
                    aria-label="קוד האימות"
                  />
                )}
              />
            </>
            :
            <Stack width="80%" gap="1vh">
              <FormLabel className="phone-label code" htmlFor="code">
                קוד האימות
              </FormLabel>
              <OTPInput
                shouldAutoFocus
                inputType="number"
                containerStyle={isMobile ? {
                  direction: "ltr",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  gap: "3vw",
                } : {
                  direction: "ltr",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  gap: "0.8vw",
                }}
                onPaste={() => { }}
                value={code}
                onChange={setCode}
                numInputs={4}
                renderInput={(props) => (
                  <input {...props} style={{}} id="code" className="number-input" />
                )}
              />
            </Stack>}
          <ResendCodeCountDown onResendCode={onResendCode} />
        </div>
        <BasicButton
          className="code"
          type="submit"
          onClick={() => smsLogin(code)}
          text="כניסה"
          isProgress={isLoading}
        />
      </motion.div>
    </form>
  );
};

export default SmsReceiver;
